export default [{
  path: 'auctionProclamationList',
  name: 'auctionProclamationList',
  component: function component() {
    return import('@/views/wasteAuctionManage/auctionProclamationManage/list');
  }
}, {
  path: 'auctionProclamationAdd',
  name: 'auctionProclamationAdd',
  component: function component() {
    return import('@/views/recoveryManage/recoveryBid/add');
  }
}, {
  path: 'auctionProclamationDetail',
  name: 'auctionProclamationDetail',
  component: function component() {
    return import('@/views/wasteAuctionManage/auctionProclamationManage/detail');
  }
}, {
  path: 'auctionProclamationSuccess',
  name: 'auctionProclamationSuccess',
  component: function component() {
    return import('@/views/wasteAuctionManage/auctionProclamationManage/success');
  }
}, {
  path: 'auctionReviewList',
  name: 'auctionReviewList',
  component: function component() {
    return import('@/views/wasteAuctionManage/auctionReviewManage/list');
  }
}, {
  path: 'auctionReviewDetail',
  name: 'auctionReviewDetail',
  component: function component() {
    return import('@/views/wasteAuctionManage/auctionReviewManage/detail');
  }
}, {
  path: 'auctionReviewSuccess',
  name: 'auctionReviewSuccess',
  component: function component() {
    return import('@/views/wasteAuctionManage/auctionReviewManage/success');
  }
}, {
  path: 'wasteSuccess',
  name: 'wasteSuccess',
  component: function component() {
    return import('@/views/wasteAuctionManage/success');
  }
}, {
  path: 'wasteReviewList',
  //立项审批
  name: 'wasteReviewList',
  component: function component() {
    return import('@/views/recoveryManage/recoveryBid/list');
  }
}, {
  path: 'wasteRevieWDetail',
  name: 'wasteRevieWDetail',
  component: function component() {
    return import('@/views/recoveryManage/recoveryBid/detail');
  }
}, {
  path: 'publicBiddingList',
  name: 'publicBiddingList',
  component: function component() {
    return import('@/views/wasteAuctionManage/biddingReviewManage/public/list');
  }
}, {
  path: 'publicBiddingDetail',
  name: 'publicBiddingDetail',
  component: function component() {
    return import('@/views/wasteAuctionManage/biddingReviewManage/public/detail');
  }
}, {
  path: 'inviteBiddingList',
  name: 'inviteBiddingList',
  component: function component() {
    return import('@/views/wasteAuctionManage/biddingReviewManage/invite/list');
  }
}, {
  path: 'publicBiddingSuccess',
  name: 'publicBiddingSuccess',
  component: function component() {
    return import('@/views/wasteAuctionManage/biddingReviewManage/public/success');
  }
}, {
  path: 'inviteBiddingDetail',
  name: 'inviteBiddingDetail',
  component: function component() {
    return import('@/views/wasteAuctionManage/biddingReviewManage/invite/detail');
  }
}, {
  path: 'inviteBiddingSuccess',
  name: 'inviteBiddingSuccess',
  component: function component() {
    return import('@/views/wasteAuctionManage/biddingReviewManage/invite/success');
  }
}, {
  path: 'uploadRecoveryFile',
  name: 'uploadRecoveryFile',
  component: function component() {
    return import('@/views/recoveryManage/recoveryBid/update');
  }
}, {
  path: 'flowDestroy',
  name: 'flowDestroy',
  component: function component() {
    return import('@/views/wasteAuctionManage/biddingReviewManage/flowDestroy');
  }
}, {
  path: 'flowDestroySuccess',
  name: 'flowDestroySuccess',
  component: function component() {
    return import('@/views/wasteAuctionManage/biddingReviewManage/success');
  }
}];